import { Icon } from '@/components/ui/icon';
import { CircleArrowDown02IconSolid } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';

interface ValueChangeArrowProps {
  direction: 'up' | 'down';
  className?: string;
}

/** A compact, circular arrow for signed value changes. */
export function ValueChangeArrow({ direction, className }: ValueChangeArrowProps): React.ReactNode {
  return (
    <Icon
      aria-hidden
      icon={CircleArrowDown02IconSolid}
      className={cn('shrink-0', direction === 'up' && 'rotate-180', className)}
    />
  );
}
